import { Layout } from "@/components/layout/Layout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Search, FileText, ShieldCheck, Truck } from "lucide-react";

const services = [
  {
    id: "sourcing",
    icon: Search,
    title: "Global Sourcing",
    description: "Leverage our extensive network of verified suppliers across India to find the perfect products for your business needs.",
    features: [
      "Access to 500+ verified manufacturers",
      "Custom product development support",
      "Sample procurement and evaluation",
      "Price negotiation assistance",
      "Factory audit and certification verification",
    ],
  },
  {
    id: "export",
    icon: FileText,
    title: "Export Management",
    description: "Complete export documentation and compliance management ensuring smooth international transactions.",
    features: [
      "Export documentation preparation",
      "Letter of Credit management",
      "Trade compliance guidance",
      "Customs clearance support",
      "Payment terms structuring",
    ],
  },
  {
    id: "quality",
    icon: ShieldCheck,
    title: "Quality Control",
    description: "Multi-stage quality assurance processes to ensure every shipment meets your exact specifications.",
    features: [
      "Pre-production inspections",
      "In-line production monitoring",
      "Final random inspections (AQL)",
      "Container loading supervision",
      "Lab testing coordination",
    ],
  },
  {
    id: "logistics",
    icon: Truck,
    title: "Logistics & Compliance",
    description: "End-to-end logistics solutions with complete visibility and regulatory compliance across borders.",
    features: [
      "Ocean and air freight booking",
      "Multi-modal transportation",
      "Warehousing solutions",
      "Real-time shipment tracking",
      "Insurance coordination",
    ],
  },
];

const Services = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="py-24 lg:py-32">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-foreground mb-6">
              India to World <span className="text-gradient-gold">Export Solutions</span>
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
              Comprehensive B2B trade services designed to simplify your sourcing, 
              quality control, and international logistics operations.
            </p>
          </div>
        </div>
      </section>

      {/* Services List */}
      <section className="pb-24">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="space-y-16">
            {services.map((service, index) => (
              <div
                key={service.id}
                id={service.id}
                className={`flex flex-col ${
                  index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
                } gap-8 lg:gap-16 items-center`}
              >
                {/* Icon */}
                <div className="w-full lg:w-1/3 flex justify-center">
                  <div className="w-48 h-48 rounded-3xl bg-gradient-card border border-border flex items-center justify-center glow-gold">
                    <service.icon className="w-24 h-24 text-primary" />
                  </div>
                </div>

                {/* Content */}
                <div className="w-full lg:w-2/3">
                  <h2 className="text-3xl md:text-4xl font-serif font-bold text-foreground mb-4">
                    {service.title}
                  </h2>
                  <p className="text-lg text-muted-foreground leading-relaxed mb-6">
                    {service.description}
                  </p>

                  {/* Features */}
                  <ul className="space-y-3 mb-8">
                    {service.features.map((feature) => (
                      <li key={feature} className="flex items-start gap-3">
                        <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />
                        <span className="text-foreground/90">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <Link to="/contact">
                    <Button variant="gold" size="lg">
                      Learn More
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Services;
